import { render, staticRenderFns } from "./AllCourses.vue?vue&type=template&id=6571fb08"
import script from "./AllCourses.vue?vue&type=script&lang=js"
export * from "./AllCourses.vue?vue&type=script&lang=js"
import style0 from "./AllCourses.vue?vue&type=style&index=0&id=6571fb08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports